import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useParams } from "react-router-dom";
import { getallProcess, getallProject } from "../api/api";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";


const Invoice = () => {
  const { id } = useParams();

  const [project, setProject] = useState(null);

  const [processes, setProcesses] = useState([]);

  const printPDF = () => {
    const invoiceElement = document.getElementById("invoice");
    if (!invoiceElement) return;

    html2canvas(invoiceElement, { scale: 5 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a5");
      const imgWidth = 148;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

      const pdfUrl = pdf.output("bloburl");
      const printWindow = window.open(pdfUrl, "_blank");
      printWindow.onload = () => {
        printWindow.print();
      };
    });
  };

  const exportToExcel = async () => {
  if (!project) return;

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Invoice");

  const border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };

  const center = { vertical: "middle", horizontal: "center", wrapText: true };

  sheet.properties.defaultRowHeight = 20;

  // Set column widths
  sheet.columns = Array(10).fill({ width: 20 });

  // MILLER AUTO TECH Title Row
  sheet.mergeCells("A1:C1");
  sheet.getCell("A1").value = "MILLER AUTO TECH";
  sheet.getCell("A1").font = { bold: true, size: 14 };
  sheet.getCell("A1").alignment = center;
  sheet.getCell("A1").border = border;

  // Material Route Card
  sheet.mergeCells("D1:F1");
  sheet.getCell("D1").value = "Material Route Card";
  sheet.getCell("D1").font = { bold: true, size: 12 };
  sheet.getCell("D1").alignment = center;
  sheet.getCell("D1").border = border;

  // Customer PO / Project
  sheet.getCell("G1").value = "Customer PO / Project";
  sheet.getCell("G1").font = { bold: true };
  sheet.getCell("G1").border = border;

  sheet.getCell("H1").value = "06L050910";
  sheet.getCell("H1").border = border;

  // Issue No and Date
  sheet.getCell("G2").value = "MAT";
  sheet.getCell("G2").font = { bold: true };
  sheet.getCell("G2").border = border;

  const issueNo = project.projectId.split("-")[1];
  const issueDate = new Date(project.createdAt).toLocaleDateString("en-US");

  sheet.getCell("H2").value = `Issue No: ${issueNo}\nIssue Date: ${issueDate}`;
  sheet.getCell("H2").alignment = { wrapText: true };
  sheet.getCell("H2").border = border;

  // Space row
  sheet.addRow([]);

  // Table Section (same layout)
  const tableRows = [
    ["M.R.C No:", project.projectId, "Material", project.metrialName],
    ["M.R.C. Open Date:", issueDate, "Grade:", ""],
    ["M.R.C. Close Date:", "", "Batch/Rolling lot no:", ""],
    ["Parent M.R.C. No:", "", "Type:", project.type],
    ["Reference Documents:", "CLUSTER ALUMINIUM CORPORATION\n#98/A, 100ft. Road Opp Fouress,\n2nd Phase Peenya Industrial Estate, Bengaluru 560058"],
    ["Dimensions (mm)", "", "Breadth", project.dimensions?.breath],
    ["", "", "Length", project.dimensions?.length],
    ["", "", "Thickness", project.dimensions?.thickness],
    ["Quantity", project.quantity],
    ["Store Location:", "", "Created by:", ""],
    ["Receiving Officer:", "", "Signature:", ""],
  ];

  tableRows.forEach((row, i) => {
    const r = sheet.addRow(row);
    r.height = 20;
    r.eachCell((cell) => {
      cell.border = border;
      cell.alignment = { vertical: "middle", wrapText: true };
    });

    // Merge cells for rows with descriptions
    if (i === 4) {
      sheet.mergeCells(`B${r.number}:D${r.number}`);
    }
    if (i === 8) {
      sheet.mergeCells(`B${r.number}:D${r.number}`);
    }
  });

  // OPERATIONS TITLE
  const opTitleRow = sheet.addRow(["OPERATIONS"]);
  sheet.mergeCells(`A${opTitleRow.number}:J${opTitleRow.number}`);
  opTitleRow.getCell(1).font = { bold: true };
  opTitleRow.getCell(1).alignment = center;
  opTitleRow.getCell(1).border = border;
  sheet.addRow([]);

  // OPERATIONS TABLE
  const headers = [
    "Sl. No",
    "Date",
    "Part No / Description",
    "Dia/Thick",
    "Breath",
    "Length",
    "Qty",
    "Inspection",
    "Acc / Rej",
    "Remarks",
  ];

  const headerRow = sheet.addRow(headers);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.border = border;
    cell.alignment = center;
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD3D3D3" },
    };
  });

  // OPERATIONS DATA
  project.processes.forEach((pro, index) => {
    const processName = processes.find((p) => p._id === pro.process)?.name || "";
    const row = sheet.addRow([
      index + 1,
      new Date(pro.createdAt).toLocaleDateString("en-US"),
      `${processName}\n${project.description}`,
      project.dimensions?.dia || project.dimensions?.thickness,
      project.dimensions?.breath,
      project.dimensions?.length,
      project.quantity,
      "",
      "-",
      "-",
    ]);

    row.eachCell((cell) => {
      cell.border = border;
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    });
  });

  // Download
  const buf = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${project.projectId}_Invoice.xlsx`);
};

  useEffect(() => {
    getallProject()
      .then((res) => {
        setProject(res.data.projects.find((p) => p._id === id));
      })
      .catch((err) => console.log(err));
    getallProcess()
      .then((res) => {
        setProcesses(res.data);
      })
      .catch((err) => console.log(err));
  }, [id]);

  if (!project) {
    return null;
  }

  return (
    // <div className="fixed bg-black bg-opacity-50 flex justify-center items-center p-10 inset-0 z-50">
      <div className="bg-white w-[800px] mx-auto mt-10 overflow-y-auto shadow-xl p-6 rounded-lg">
        <div className=" flex justify-end">
          <button onClick={printPDF} className=" bg-black text-white px-4 py-2">
            Print
          </button>
          <button onClick={exportToExcel} className="bg-green-600 text-white px-4 py-2">
          Export to Excel
        </button>

        </div>
        <div className=" p-5" id="invoice">
          <div className=" grid grid-cols-3 border border-black w-full h-auto">
            <h2 className="text-xl font-bold text-center px-2 py-6 border-r border-black">
              MILLER AUTO TECH
            </h2>
            <h3 className="text-lg font-semibold text-center px-2 py-6  border-r border-black">
              Material Route Card
            </h3>
            <table className=" p-0 text-sm">
              <tr className=" border-b border-black w-full">
                <td className=" px-2">
                  <strong className="">Customer PO / Project :</strong>
                </td>
                <td className=" border-l border-black px-2">06L050910</td>
              </tr>
              <tr>
                <td className=" px-2">
                  <strong className="">MAT</strong>
                </td>
                <td className=" border-l border-black px-2">
                  <p>
                    <strong className=" text-[12px]">Issue No:</strong>{" "}
                    {project.projectId.split("-")[1]}
                  </p>
                  <p>
                    <strong className=" text-[12px]">Issue Date:</strong>{" "}
                    {new Date(project.createdAt).toLocaleDateString("en-us")}
                  </p>
                </td>
              </tr>
            </table>
          </div>

          <table className="w-full text-sm">
            <tbody>
              <tr className="border border-t-0 border-black">
                <td className="w-1/4 px-2 py-1 bg-gray-500">M.R.C No:</td>
                <td className="w-1/4 border-l border-black px-2 py-1">
                  {project.projectId}
                </td>
                <td className="w-1/4 px-2 py-1 border-l border-black  bg-gray-500">
                  Material
                </td>
                <td className="w-1/4 border-l border-black px-2 py-1">
                  {project.metrialName}
                </td>
              </tr>
              <tr className="border border-t-0 border-black">
                <td className="px-2 py-1 border-l border-black  bg-gray-500">
                  M.R.C. Open Date:
                </td>
                <td className="border-l border-black">
                  {new Date(project.createdAt).toLocaleDateString("en-us")}
                </td>
                <td className="px-2 py-1 border-l border-black bg-gray-500">
                  Grade:
                </td>
                <td className="border-l border-black"></td>
              </tr>
              <tr className="border border-t-0 border-black">
                <td className="px-2 py-1 border-l border-black  bg-gray-500">
                  M.R.C. Close Date:
                </td>
                <td className="border-l border-black"></td>
                <td className="px-2 py-1 border-l border-black  bg-gray-500">
                  Batch/Rolling lot no:
                </td>
                <td className="border-l border-black"></td>
              </tr>
              <tr className="border border-t-0 border-black">
                <td className="px-2 py-1 border-l border-black  bg-gray-500">
                  Parent M.R.C. No:
                </td>
                <td className="border-l border-black"></td>
                <td className="px-2 py-1 border-l border-black  bg-gray-500">
                  Type:
                </td>
                <td className="border-l border-black">{project.type}</td>
              </tr>
              <tr className="border border-t-0 border-black align-top">
                <td
                  className="px-2 py-1 border-l border-black  bg-gray-500"
                  rowSpan={5}
                >
                  Reference Documents:
                </td>
                <td className="border-l border-black" rowSpan={5}>
                  CLUSTER ALUMINIUM CORPORATION <br />
                  #98/A, 100ft. Road Opp Fouress, 2nd Phase Peenya Industrial
                  Estate, Bengaluru 560058
                </td>
              </tr>
              <tr className="border border-t-0 border-black">
                <td
                  className="px-2 py-1 border-l border-black  bg-gray-500"
                  rowSpan={3}
                >
                  Dimensions (mm)
                </td>
               {project.type !== "circle" ?<> <td className="border-l border-black px-2 py-1  bg-gray-500">
                  Breadth
                </td>
                <td className="px-2 py-1 border-l border-black" colSpan={2}>
                  {project.dimensions?.breath}
                </td>
                </>:
                <>
                <td className="border-l border-black px-2 py-1  bg-gray-500">
                  Dia
                </td>
                <td className="px-2 py-1 border-l border-black" colSpan={2}>
                  {project.dimensions?.dia}
                </td>
                </>}
                
              </tr>
              <tr className="border border-t-0 border-black">
                <td className="border-l border-black px-2 py-1  bg-gray-500">
                  Length
                </td>
                <td className="px-2 py-1 border-l border-black" colSpan={2}>
                  {project.dimensions?.length}
                </td>
              </tr>
              <tr className="border border-t-0 border-black">
                <td className="border-l border-black px-2 py-1   bg-gray-500">
                  Thickness
                </td>
                <td className="px-2 py-1 border-l border-black" colSpan={2}>
                  {project.dimensions?.thickness}
                </td>
              </tr>

              <tr className="border border-t-0 border-black">
                <td className="px-2 py-1 border-l border-black  bg-gray-500">
                  Quantity
                </td>
                <td className="border-l border-black">{project.quantity}</td>
              </tr>
              <tr className="border border-t-0 border-black">
                <td className="px-2 py-1 border-l border-black  bg-gray-500">
                  Store Location:
                </td>
                <td className="border-l border-black"></td>
                <td className="px-2 py-1 border-l border-black  bg-gray-500">
                  Created by:
                </td>
                <td className="border-l border-black"></td>
              </tr>
              <tr className="border border-t-0 border-black">
                <td className="px-2 py-1 border-l border-black  bg-gray-500">
                  Receiving Officer:
                </td>
                <td className="border-l border-black"></td>
                <td className="px-2 py-1 border-l border-black  bg-gray-500">
                  Signature:
                </td>
                <td className="border-l border-black"></td>
              </tr>
            </tbody>
          </table>

          <div className="text-base font-semibold text-center px-2 py-1 bg-gray-400 border-l border-r border-black">
            OPERATIONS
          </div>

          <table className="w-full text-sm border border-collapse border-black">
            <thead>
              <tr className="bg-gray-200">
                <th className="border border-black px-2 py-1" rowSpan={2}>
                  Sl. No
                </th>
                <th className="border border-black px-2 py-1" rowSpan={2}>
                  Date
                </th>
                <th className="border border-black px-2 py-1" rowSpan={2}>
                  Part No / Description
                </th>
                <th className="border border-black px-2 py-1" colSpan={3}>
                  Cut Piece Dimension (mm)
                </th>
                <th className="border border-black px-2 py-1" rowSpan={2}>
                  Qty
                </th>
                <th className="border border-black px-2 py-1" rowSpan={2}>
                  Inspection
                </th>
                <th className="border border-black px-2 py-1" rowSpan={2}>
                  Acc / Rej
                </th>
                <th className="border border-black px-2 py-1" rowSpan={2}>
                  Remarks
                </th>
              </tr>
              <tr className="bg-gray-200">
                <th className="border border-black px-2 py-1">Dia/Thick</th>
                <th className="border border-black px-2 py-1">Breath</th>
                <th className="border border-black px-2 py-1">Length</th>
              </tr>
            </thead>

            <tbody>
              {project.processes.map((pro, index) => (
                <tr key={pro._id}>
                  <td className="border border-black px-2 py-1 text-center">
                    {index + 1}
                  </td>
                  <td className="border border-black px-2 py-1 text-center">
                    {new Date(pro.createdAt).toLocaleDateString("en-us")}
                  </td>
                  <td className="border border-black px-2 py-1 text-center">
                    {/* {processes.find((p) => p._id === pro.process)?.name}
                    <br /> */}
                    {project.partNo} <br />
                    <span className=" text-xs">{project.description}</span>
                  </td>
                  <td className="border border-black px-2 py-1 text-center">
                    {project.dimensions?.dia || project.dimensions?.thickness}
                  </td>
                  <td className="border border-black px-2 py-1 text-center">
                    {project.dimensions?.breath}
                  </td>
                  <td className="border border-black px-2 py-1 text-center">
                    {project.dimensions?.length}
                  </td>

                  <td className="border border-black px-2 py-1 text-center">
                    {project.quantity}
                  </td>
                  <td className="border border-black px-2 py-1 text-center">
                    {/* Accepted */}
                  </td>
                  <td className="border border-black px-2 py-1 text-center">
                    -
                  </td>
                  <td className="border border-black px-2 py-1 text-center">
                    -
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    // </div>
  );
};

export default Invoice;
